export class RingBuffer<T> {
	private buf: T[];
	private head = 0;
	private size = 0;

	constructor(public readonly capacity: number) {
		if (capacity <= 0) throw new Error("capacity must be > 0");
		this.buf = new Array<T>(capacity);
	}

	push(value: T): T | undefined {
		const evicted =
			this.size === this.capacity ? this.buf[this.head] : undefined;
		this.buf[this.head] = value;
		this.head = (this.head + 1) % this.capacity;
		if (this.size < this.capacity) this.size++;
		return evicted;
	}

	get length() {
		return this.size;
	}

	at(i: number): T | undefined {
		if (i < 0 || i >= this.size) return undefined;
		const start = (this.head - this.size + this.capacity) % this.capacity;
		return this.buf[(start + i) % this.capacity];
	}

	toArray(): T[] {
		const out = new Array<T>(this.size);
		for (let i = 0; i < this.size; i++) out[i] = this.at(i)!;
		return out;
	}

	clear() {
		this.head = 0;
		this.size = 0;
	}
}
